<div class="loginform">
    <div class="lblmsg">
       <label class="logininfo">The email address is associated with muliple firms.</label>
       <label class="logininfo">Please select firm to sign in</label>
    </div>
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
    <div class="lblmsg">
        <label id="id_alert" class="logininfo"></label>
    </div>
    <div class="form-floating mb-3 mt-3">
        <select class="form-select custselect"
                formControlName="firmname">
          <option *ngFor="let item of firms; let i = index"
                  [ngValue]="item.id">{{ item.firmName }}</option>
        </select>
        <label for="firmname" class="lblfocus">Select Firm</label>
    </div>
   <div class="form-floating mt-3 mb-3">
       <input formControlName="password"
             class="form-control custominput"
             [type]="showPassword?'text':'password'"
             inputmode="passsword"
             id="id_password"
             placeholder="Password"/>
       <label for="password" class="lblfocus">Password</label>
        <img src="/assets/img/eye_open.svg"
             class="input-group-append viewpass"
             *ngIf='showPassword'
             (click)="showPassword = false">
        <img src="/assets/img/eye_close.svg"
             *ngIf='!showPassword'
             class="input-group-append viewpass"
             (click)="showPassword = true">
        <div *ngIf="submitted && f['password'].errors" class="text-danger">
            <div *ngIf="f['password'].errors">Password is required</div>
            <div *ngIf="f['password'].errors">{{f['password'].errors['msg']}}</div>
        </div>
    </div> 
   <div class="btnlogin">
      <button type="button"
              (click)="cancelml()"
              class="btn btn-secondary btnlogincancel btncomman">Cancel</button>
      <button type="submit" class="btn btn-primary btnloginsubmit btncomman">Submit</button>
    </div> 
  </form>
</div>
<div *ngIf="showTC">
  <div class="modal-backdrop show"></div>
  <div class="modal show" style="padding-right: 15px; display: block;">
    <div class="modal-dialog modal-lg" id="dialog-box">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title pull-left">Terms & Conditions</h5>
          <button type="button" class="close pull-right" aria-label="Close" (click)="closeAgreement()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <iframe width="100%" style="height: 72vh;" src="assets/site/RegsWatchEndCustomerTC.pdf"></iframe>
        </div>

        <div class="modal-footer">
          <p class="text-left">
            By clicking on <strong>"Agree"</strong>, you confirm that you have read and accept the terms and conditions of DigiCoffer, Inc.
          </p>
          <button type="button" class="btn btn-danger modal-close" (click)="closeAgreement()">Close</button>
          <button type="button" class="btn btn-primary" (click)="agree()">Agree</button>
        </div>
      </div>
    </div>
  </div>
</div>